export * from './inventory-dashboard.component';
export * from './inventory-dashboard-routing.module';
export * from './inventory-dashboard.module';